import { addShortcutsExtension } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/shortcuts/index.js?vue3';
import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';
import initBoards from '/builds/gitlab/gitlab-ee/app/assets/javascripts/boards/index.js?vue3';

addShortcutsExtension(ShortcutsNavigation);
initBoards();
